var _circle, _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _path10, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _ellipse, _path11, _rect2, _ellipse2, _path12, _rect3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSavannahJeepGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#F1F2F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.0978 53.5008C77.0978 52.6405 76.4004 51.9431 75.5401 51.9431H74.5016C73.6413 51.9431 72.9439 52.6405 72.9439 53.5008V53.9552C72.9439 54.8155 72.2465 55.5129 71.3861 55.5129H10.1154C9.25504 55.5129 8.55762 56.2103 8.55762 57.0706V58.9529C8.55762 59.8132 9.25504 60.5106 10.1153 60.5106H75.5401C76.4004 60.5106 77.0978 59.8132 77.0978 58.9529V53.5008Z",
    fill: "#818A98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0978 52.2893C77.0978 52.0981 76.9428 51.9431 76.7517 51.9431C76.5605 51.9431 76.4055 52.0981 76.4055 52.2893V57.525C76.4055 58.3853 75.7081 59.0827 74.8478 59.0827H9.27158C8.87727 59.0827 8.55762 59.4024 8.55762 59.7967C8.55762 60.191 8.87727 60.5106 9.27157 60.5106H75.5401C76.4004 60.5106 77.0978 59.8132 77.0978 58.9529V52.2893Z",
    fill: "#505862"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1846 19.1692H52.498L58.6673 40.7615H56.3538L50.1846 19.1692Z",
    fill: "#B9BEC6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1348 23.7957H51.7271L55.5829 38.4476H30.1348V23.7957Z",
    fill: "#D5D8DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1348 23.7957H36.304L40.1598 38.4476H30.1348V23.7957Z",
    fill: "#9DA4AF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.3975,
    y: 29.9661,
    width: 14.6519,
    height: 9.25385,
    rx: 1.55773,
    fill: "#9DA4AF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3975 31.5238C12.3975 30.6635 13.0949 29.9661 13.9552 29.9661H17.0244V39.2199H13.9552C13.0949 39.2199 12.3975 38.5225 12.3975 37.6622V31.5238Z",
    fill: "#67717E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6763 20.0275C31.6763 18.5265 29.762 17.8938 28.8675 19.0994L15.7841 36.7335C15.0215 37.7614 15.7552 39.2194 17.0352 39.2194H19.4418C19.1542 38.7263 19.1322 38.0801 19.5104 37.5398L25.7569 28.6162C26.6303 27.3685 28.5908 27.9865 28.5908 29.5095L28.5908 38.4331C28.5907 38.7199 28.5132 38.9886 28.378 39.2194H30.1184C30.9788 39.2194 31.6762 38.522 31.6762 37.6617L31.6763 20.0275Z",
    fill: "#B9BEC6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3633 39.2192H30.1344C30.9862 39.2192 31.6767 38.5286 31.6767 37.6768V19.9806C31.6767 18.7219 30.3174 18.08 29.3633 18.6379V39.2192Z",
    fill: "#D5D8DD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8945 42.5975C10.8945 40.4467 12.6381 38.7031 14.7889 38.7031H71.6461C73.7969 38.7031 75.5404 40.4467 75.5404 42.5975V55.8382H10.8945V42.5975Z",
    fill: "#B9BEC6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8555 42.3416C10.8555 40.1908 12.599 38.4473 14.7498 38.4473H26.0387C27.5892 38.4473 28.9919 39.367 29.6101 40.7888L36.3036 56.1838H10.8555V42.3416Z",
    fill: "#818A98"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5199,
    cy: 58.6137,
    r: 11.683,
    fill: "#67717E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5192,
    cy: 58.6135,
    r: 5.8415,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5208,
    cy: 58.614,
    r: 4.38112,
    fill: "#9DA4AF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9144,
    cy: 58.6139,
    r: 11.683,
    fill: "#67717E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9138,
    cy: 58.614,
    r: 5.8415,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9153,
    cy: 58.6143,
    r: 4.38112,
    fill: "#9DA4AF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.1779,
    cy: 44.6167,
    rx: 1.92789,
    ry: 4.62693,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7923 44.6167C74.7923 47.1721 76.2426 49.2436 75.1779 49.2436C74.1131 49.2436 73.25 47.1721 73.25 44.6167C73.25 42.0613 74.1131 39.9897 75.1779 39.9897C76.2426 39.9897 74.7923 42.0613 74.7923 44.6167Z",
    fill: "#D5D8DD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 39.9897,
    width: 3.85577,
    height: 14.6519,
    rx: 1.55773,
    fill: "#67717E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5203,
    cy: 16.4702,
    rx: 2.69904,
    ry: 3.4702,
    fill: "#D5D8DD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7492 16.4702C29.7492 18.3867 32.011 19.9404 30.5203 19.9404C29.0297 19.9404 27.8213 18.3867 27.8213 16.4702C27.8213 14.5537 29.0297 13 30.5203 13C32.011 13 29.7492 14.5537 29.7492 16.4702Z",
    fill: "#9DA4AF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.0742,
    y: 40.7617,
    width: 6.94039,
    height: 2.31346,
    rx: 1.15673,
    fill: "#9DA4AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavannahJeepGray);
export default __webpack_public_path__ + "static/media/SavannahJeep-gray.3505181c5feca42fa2141e0c5accca25.svg";
export { ForwardRef as ReactComponent };